  import { LocationNumbersService } from "../../../services"

  const verificationCall = async function ({ commit }, payload) {
    try {
      const { data } = await LocationNumbersService.getVerificationCall(
        payload
      )

      return Promise.resolve(data)
    } catch (error) {
      return Promise.reject(error)
    }
  }

  export default verificationCall
